import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pending: {
    defaultMessage: 'Pending',
    description: 'Status Option pending'
  },
  settled: {
    defaultMessage: 'Settled',
    description: 'Status Option settled'
  },
  voided: {
    defaultMessage: 'Voided',
    description: 'Status Option voided'
  },
  reconciled: {
    defaultMessage: 'Reconciled',
    description: 'Status Option reconciled'
  },
  status: {
    defaultMessage: 'Status',
    description: 'Payment status'
  }
});
